import * as React from "react";
import Rating from "react-rating";
import jfetch from "../../utils/jfetch";

interface IProps {
  userContext: IUserContextData;
  course: any;
  voted: boolean;
}

interface IState {
  avgRating: number;
  voted: boolean;
}

class Rater extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    avgRating: 0,
    voted: false
  };

  componentDidMount() {
    this.setState({
      avgRating: this.props.course.cached_weighted_average,
      voted: this.props.voted
    });

  }

  async handleVote(rate) {
    let response = await jfetch.post(`/library/courses/${this.props.course.id}/voted`, {
      "value": rate,
      "voted": "true"
    });
    if (response.votedReturn) {
      this.setState({
        avgRating: response.avgRating,
        voted: true
      });
    }
  }

  render() {
    return (
      <Rating
        emptySymbol="fa fa-star-o fa"
        fullSymbol="fa fa-star fa"
        initialRating={this.state.avgRating}
        onChange={(rate) => this.handleVote(rate)}
        readonly={this.state.voted}
      />
    );
  }
}

export default Rater;



// WEBPACK FOOTER //
// ./app/javascript/components/courses/Rater.tsx